
import { Vehicle } from "../../DataStructures/Vehicle/Vehicle";
import { Trip } from "../../DataStructures/Trip/Trip";

export class VehicleRatio{
    vehicle : Vehicle;
    ratio: number;
    trip:Trip;

    constructor(vehicle:Vehicle,ratio:number,trip:Trip){
        this.vehicle = vehicle;
        this.ratio = ratio;
        this.trip = trip;
        
    }
}